import { colors } from 'theme'

export const defaultThemeStyles = {
    separator: colors.greyLight,
    iconBackground: colors.greyLight,
    border: colors.cloud,
}
